import { render } from "./ExtSubscribeButton.vue?vue&type=template&id=5981056b&scoped=true"
import script from "./ExtSubscribeButton.vue?vue&type=script&lang=js"
export * from "./ExtSubscribeButton.vue?vue&type=script&lang=js"

import "./ExtSubscribeButton.vue?vue&type=style&index=0&id=5981056b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5981056b"],['__file',"src/components/ExtSubscribeButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5981056b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5981056b', __exports__)) {
    api.reload('5981056b', __exports__)
  }
  
  module.hot.accept("./ExtSubscribeButton.vue?vue&type=template&id=5981056b&scoped=true", () => {
    api.rerender('5981056b', render)
  })

}


export default __exports__